export function formatUnitLabel(title: string, symbol?: string | null): string {
  return symbol ? `${title} (${symbol})` : title;
}

export function formatYearlyCosts(value: number | null | undefined, locale: string): string | null {
  if (value === null || value === undefined) return null;
  return value.toLocaleString(locale, { style: "currency", currency: "EUR" });
}

export function formatReductionImpact(value: number | null | undefined, locale: string): string | null {
  if (value === null || value === undefined) return null;
  return `${value.toLocaleString(locale)} tCO₂e`;
}

export function formatLocaleDate(value: string | Date | null | undefined, locale: string): string | null {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toLocaleDateString(locale);
}
